// src/App.js
import React from "react";
import BoqUploadPage from "./pages/BoqUploadPage"; // adjust path if different
import "./App.css"; // and/or your BoqUploadPage.css

function App() {
  return <BoqUploadPage />;
}

export default App;
